
// SVG Icon: forward
export default { id: "terriajs-forward" };
export const id = "terriajs-forward";
export const name = "forward";
